<template>
  <component
    :is="peek"
    :event="event"
  />
</template>

<script>
import AccountEvent from '@/plugins/sdk/resources/Account/Event'
import AccountPeek from '@/components/Application/Sales/Events/Event/Peek/Account'
import OpportunityPeek from '@/components/Application/Sales/Events/Event/Peek/Opportunity'

export default {
  components: {
    AccountPeek,
    OpportunityPeek
  },
  props: {
    event: {
      type: Object,
      required: true,
      validator: function (value) {
        return value instanceof AccountEvent
      }
    }
  },
  computed: {
    peek () {
      if (this.event.account.status === 'lead') {
        return OpportunityPeek
      } else {
        return AccountPeek
      }
    }
  }
}
</script>
